// extracted by mini-css-extract-plugin
export default {"monthlyIncomeTable":"MonthlyNetIncomeInfo_monthlyIncomeTable__ZLaky"};